import { useContext } from 'react';

import AuthenticationContext from './AuthenticationContext';
import { PermissionsContext } from './PermissionsContext';

export const useAuthentication = () => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error(
      'useAuthentication must be used within an AuthenticationProvider',
    );
  }
  return context;
};
export const usePermissions = () => useContext(PermissionsContext);
